/**
 * Legacy preview route — redirects to the canonical public invoice page.
 * Kept for backward-compat with older payment-link URLs that used /previewinvoice/:id.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(public)/previewinvoice/$id')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/invoice/$id', params: { id: params.id }, replace: true });
  },
  component: () => null,
});
